import { useContext } from "react"
import { motion } from "motion/react"

import { AppContext } from "../App"
import { LetterStatus } from "../helpers"

type Props = {
  letterPos: number
  attemptVal: number
}

function Letter({ letterPos, attemptVal }: Props) {
  const { board, boardStatus } = useContext(AppContext)
  const letter = board[attemptVal][letterPos]

  let letterState = ""
  const status = boardStatus[attemptVal][letterPos]

  switch (status) {
    case LetterStatus.Letter:
      letterState = "almost"
      break
    case LetterStatus.LetterAndPosition:
      letterState = "correct"
      break
    case LetterStatus.Disabled:
      letterState = "error"
      break
    default:
      break
  }

  const shouldReveal = status !== LetterStatus.Unknown
  const isCorrectLetter = status === LetterStatus.LetterAndPosition

  return (
    <motion.div
      key={`${attemptVal}-${letterPos}-${status}`}
      className={`letter ${letter ? "filled" : ""}`}
      id={letterState}
      style={{ ["--letter-index" as string]: letterPos }}
      initial={
        shouldReveal
          ? {
              rotateX: 90,
              opacity: 0.65,
              scale: isCorrectLetter ? 0.93 : 0.96,
            }
          : false
      }
      animate={
        shouldReveal
          ? isCorrectLetter
            ? {
                rotateX: 0,
                opacity: 1,
                scale: [1.08, 1],
              }
            : { rotateX: 0, opacity: 1, scale: 1 }
          : { rotateX: 0, opacity: 1, scale: 1 }
      }
      transition={{ duration: 1.26, delay: shouldReveal ? letterPos * 0.27 : 0 }}
    >
      {letter}
    </motion.div>
  )
}

export default Letter
